import type { TicketSection as GQLItem } from '../../../generated/api.graphql';
import { take } from '../../../util';

/** A shared allotment pool that section-backed tickets draw from — the model's `TicketBucket` (ADR-014 decision 5). */
export type TicketSection = {
  id: number;
  name: string | null;
  color: string;
  quantity: number;
  remaining: number;
  editable: boolean;
};

export const fromGql = (item: GQLItem): TicketSection => ({
  ...take<TicketSection>(item, 'id', 'color', 'quantity', 'remaining', 'editable'),
  name: item.name ?? null,
});
